import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const PUT_CONFI_COST_RESET = 'PUT_CONFI_COST_RESET';
export const PUT_CONFI_COST_LOADING = 'PUT_CONFI_COST_LOADING';
export const PUT_CONFI_COST_SUCCESS = 'PUT_CONFI_COST_SUCCESS';
export const PUT_CONFI_COST_REJECT = 'PUT_CONFI_COST_REJECT';

//* ACTIONS ------------------------------------------------
export const putConfiCostReset = () => ({ type: PUT_CONFI_COST_RESET });
export const putConfiCostLoading = () => ({ type: PUT_CONFI_COST_LOADING });
export const putConfiCostSuccess = (payload) => ({ type: PUT_CONFI_COST_SUCCESS, payload });
export const putConfiCostReject = (payload) => ({ type: PUT_CONFI_COST_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const putConfiCostRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.PUT,
        data,
    }, getState);
    return request(`/Costs/web/UpdateCosts`, options);
};
